import { Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgentesCausantesEnfermedadProfesional,
  getAmbitosDeteccionEnfermedadProfesional,
  getGravedades,
  getZonasAfectadas,
  putDiagnosticoEnfermedad,
  saveDiagnosticoEnfermedad,
} from "../../../../../redux/actions/denuncia";
import FormikActions from "../../../../commons/formik/FormikActions";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledNuevaDenuncia } from "../../../../styled/Siniestros";
import { agregarDiagnosticoEnfermedadValidation, agregarDiagnosticoEnfermedadValidationWithFechaExamen, } from "../validation/formValidation";

const DiagnosticoEnfermedadDialog = ({
  onEdit,
  handleClose,
  open,
  diagnostico,
  setOnEditFalse,
  disabledCheck,
  firstDiag,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    diagnosticoOms: null,
    gravedad: null,
    fechaInicio: null,
    principal: firstDiag,
    ambitoDeteccionEnfermedadProfesional: null,
    fechaExamen: null,
    zonaAfectada: null,
  };

  const diagnosticoOMS = useSelector((state) => state.denuncia.diagnosticosOMS);
  const gravedades = useSelector((state) => state.denuncia.gravedades);
  const zonasAfectadas = useSelector((state) => state.denuncia.zonasAfectadas);
  const ambitoDeteccionEnfermedadProfesional = useSelector(
    (state) => state.denuncia.ambitosDeteccionEnfermedadProfesional
  );

  const [indice, setIndice] = useState(1);
  const [tipoAmbitoDeteccion, setTipoAmbitoDeteccion] = useState("");
  const [descAmbitoDeteccion, setDescAmbitoDeteccion] = useState("");
  const [descGravedad, setDescGravedad] = useState("");
  const [descZonasAfectadas, setDescZonasAfectadas] = useState("");
  const [descDiagnosticoOms, setDescDiagnosticoOms] = useState("");
  const [diagnosticoState, setDiagnosticoState] = useState(initialValues);
  const [disabledFechaExamen, setDisableFechaExamen] = useState(true);
  const [principal, setPrincipal] = useState(false);

  useEffect(() => {
    if (tipoAmbitoDeteccion === "R" && (principal || initialValues.principal)) {
      setDisableFechaExamen(false);
    } else {
      setDisableFechaExamen(true);
    }
  }, [tipoAmbitoDeteccion, principal]);

  useEffect(() => {
    if (diagnostico) {
      setDiagnosticoState(diagnostico);
    }
  }, [diagnostico]);

  const handleSumbit = (values) => {
    if (onEdit) {
      const valores = { ...values, id: diagnosticoState.id };
      dispatch(putDiagnosticoEnfermedad(valores));
      setOnEditFalse();
    } else {
      values = {
        ...values,
        id: indice,
        descAmbitoDeteccion: descAmbitoDeteccion,
        descGravedad: descGravedad,
        descZonasAfectadas: descZonasAfectadas,
        descDiagnosticoOms: descDiagnosticoOms,
      };

      dispatch(saveDiagnosticoEnfermedad(values));
      setIndice(indice + 1);
    }
    setTipoAmbitoDeteccion("");
    setPrincipal(false);
    handleClose();
  };

  const handleGetValues = (value) => {
    dispatch(getGravedades(value));
    dispatch(getAgentesCausantesEnfermedadProfesional(value));
    dispatch(getZonasAfectadas(value));
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        {onEdit ? "Editar" : "Agregar"} Diagnóstico de Enfermedad
      </DialogTitle>
      {!diagnostico ? (
        <StyledNuevaDenuncia.DialogLoading>
          <CircularLoading />
        </StyledNuevaDenuncia.DialogLoading>
      ) : (
        <Formik
          initialValues={onEdit ? diagnostico : initialValues}
          validationSchema={
            disabledFechaExamen
              ? agregarDiagnosticoEnfermedadValidation
              : agregarDiagnosticoEnfermedadValidationWithFechaExamen
          }
          onSubmit={handleSumbit}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <DialogContent>
                <StyledNuevaDenuncia.RowContainer>
                  <StyledNuevaDenuncia.InputContainer>
                    <StyledNuevaDenuncia.Input
                      name="diagnosticoOms"
                      label="Diagnóstico CIE-10 *"
                      options={diagnosticoOMS.data}
                      renderOption={(option) => option.nombre}
                      filterOptions={(option) => option.nombre}
                      callBack={(value) => {
                        if (value) {
                          let arr = value.nombre.split(" - ");
                          handleGetValues(value);
                          setDescDiagnosticoOms(arr[1]);
                        }
                      }}
                    />
                  </StyledNuevaDenuncia.InputContainer>
                </StyledNuevaDenuncia.RowContainer>
                <StyledNuevaDenuncia.RowContainer>
                  <StyledNuevaDenuncia.InputContainer>
                    <StyledNuevaDenuncia.Input
                      name="gravedad"
                      label="Gravedad"
                      options={gravedades.data}
                      renderOption={(option) => option.nombre}
                      filterOptions={(option) => option.nombre}
                      disabled={!values.diagnosticoOms}
                      getOptions={() =>
                        dispatch(getGravedades(values.diagnosticoOms))
                      }
                      callBack={(value) => {
                        if (value) {
                          setDescGravedad(value.nombre);
                        }
                      }}
                    />
                  </StyledNuevaDenuncia.InputContainer>
                  <StyledNuevaDenuncia.InputContainer>

                    <StyledNuevaDenuncia.RightInput
                      name="fechaInicio"
                      label="Fecha PMI *"
                      disabled={!values.diagnosticoOms}
                      disableFuture
                    />
                  </StyledNuevaDenuncia.InputContainer>
                  <StyledNuevaDenuncia.Checkbox
                    name="principal"
                    label="Principal"
                    onBlur={(value) => {
                      if (value.target.checked) {
                        setPrincipal(true);
                      } else {
                        setPrincipal(false);
                        setFieldValue("fechaExamen", null);
                      }
                    }}
                    disabled={disabledCheck || firstDiag}
                  />
                </StyledNuevaDenuncia.RowContainer>
                <StyledNuevaDenuncia.RowContainer>
                  <StyledNuevaDenuncia.InputContainer>
                    <StyledNuevaDenuncia.Input
                      name="ambitoDeteccionEnfermedadProfesional"
                      label="Ámbito de detección *"
                      disabled={!values.diagnosticoOms}
                      options={ambitoDeteccionEnfermedadProfesional.data}
                      renderOption={(option) => option.nombre}
                      filterOptions={(option) => option.nombre}
                      getOptions={() =>
                        dispatch(getAmbitosDeteccionEnfermedadProfesional())
                      }
                      callBack={(value) => {
                        if (value) {
                          let arr = value.nombre.split(" - ");
                          setDescAmbitoDeteccion(value.nombre);
                          setTipoAmbitoDeteccion(arr[0]);
                          if (arr[0] !== "R") {
                            setFieldValue("fechaExamen", null);
                          }
                        }
                      }}
                    />
                  </StyledNuevaDenuncia.InputContainer>
                  <StyledNuevaDenuncia.InputContainer>
                    <StyledNuevaDenuncia.RightInput
                      name="fechaExamen"
                      disabled={disabledFechaExamen}
                      label="Fecha del Examen"
                      disableFuture
                    />
                  </StyledNuevaDenuncia.InputContainer>
                </StyledNuevaDenuncia.RowContainer>
                <StyledNuevaDenuncia.RowContainer>
                  <StyledNuevaDenuncia.InputContainer>
                    <StyledNuevaDenuncia.Input
                      name="zonaAfectada"
                      label="Zona afectada *"
                      disabled={!values.diagnosticoOms}
                      options={zonasAfectadas.data}
                      renderOption={(option) => option.nombre}
                      filterOptions={(option) => option.nombre}
                      getOptions={() =>
                        dispatch(getZonasAfectadas(values.diagnosticoOms))
                      }
                      callBack={(value) => {
                        if (value) {
                          let array = value.nombre.split(" - ");
                          setDescZonasAfectadas(array[1]);
                        }
                      }}
                    />
                  </StyledNuevaDenuncia.InputContainer>
                </StyledNuevaDenuncia.RowContainer>
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleClose}></FormikActions>
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};

export default DiagnosticoEnfermedadDialog;
